import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function CalculateRiskLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'navigation-calculate-risk-link'}
            title={intl.formatMessage({id: 'navigation.link.calculateRisk.title'})}
            to={Routes.REPORTS_CALCULATE_RISK}
        >
            <span>
                <FormattedMessage id={'navigation.link.calculateRisk.text'} />
            </span>
        </NavLink>
    );
}
